import { useEdit } from './useUpdate'

export const limits = {
  update: useEdit,
}
